import { render, staticRenderFns } from "./BreadcrumbCollection.vue?vue&type=template&id=05936cc6&"
import script from "./BreadcrumbCollection.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports